import React from "react";
import "../Home/Home.css";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";
import { motion as m } from "framer-motion";

const Blog2 = () => {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      {/* <Header /> */}
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-36 sm:pt-32">
          <div className="flex justify-center items-center py-5 w-full bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold rounded-lg transition-all duration-200 ease-in-out">
            <div className="grid grid-cols-1 sm:grid-cols-[200px_auto] gap-2 sm:gap-5 sm:justify-center w-full">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a25d6635-69c1-4c9b-868f-2e4ed302a100/public" //Init_Blog2.webp
                alt="Img"
                className="flex justify-end w-36 sm:w-48 -mt-10 sm:mt-0 sm:-mb-20 shadow-custom dark:shadow-white"
              />

              <p
                className="font-light capitalize mt-2 text-2xl lg:text-3xl transition-all duration-200 ease-in-out"
                style={{ lineHeight: 1.5 }}
              >
                Tech Trends 2024: <br />
                <span className="font-semibold">
                  Why React is the Best Choice{" "}
                  <br className="hidden md:block" /> for Modern Web Apps
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pt-0 pb-10 sm:py-10 space-y-6 text-justify">
          <p>
            React has quickly become one of the most popular tools for building
            websites and web apps.
          </p>

          <p>
            It was created by Facebook and is now used by companies worldwide,
            including Init Technology because it’s fast, flexible, and easy to
            work with.
          </p>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <div className="space-y-3">
            <p>1. Easy-to-Use Components</p>
            <p>2. Fast Loading with the Virtual DOM</p>
            <p>3. Big Community and Lots of Resources</p>
            <p>4. Flexibility in Integrations</p>
            <p>5. Optimised for SEO</p>
            <p>6. React Native for Mobile Apps</p>
          </div>

          <p>
            React has a huge community of developers who are constantly
            contributing to its growth. This means that if you run into a
            problem or need a specific tool, there’s likely already a solution
            or plugin available.
          </p>

          <p>
            Another big advantage of React is its performance, made possible by
            something called the Virtual DOM. In traditional web development,
            the entire web page would need to reload whenever there was a
            change, which could slow things down. But with React, only the parts
            of the page that actually need to be updated get changed, thanks to
            the Virtual DOM. This means faster load times and a smoother
            experience for users, especially on complex, data-heavy websites.
          </p>

          <p>
            React also boasts a huge community of developers who constantly
            contribute to its ecosystem. This massive community is a significant
            asset because it provides a wealth of resources. If you run into any
            challenges while developing with React, chances are someone has
            already solved the issue. Plus, there’s always ongoing development
            and improvements, so React remains at the forefront of modern web
            development.
          </p>

          <p>
            One of the reasons React appeals to businesses, beyond its technical
            merits, is its SEO potential. While React is mainly a client-side
            library, it can be optimized for search engines using techniques
            like server-side rendering. This is crucial in today’s digital
            world, where being search-engine friendly can make or break a
            website’s visibility. By ensuring that React apps can be indexed
            properly, companies can benefit from better SEO performance without
            sacrificing functionality.
          </p>

          <p>
            React has earned its reputation as the best choice for building
            modern web applications. Its component-based structure, performance
            through the Virtual DOM, robust community, and ability to work
            seamlessly across both web and mobile platforms make it a versatile
            and powerful tool for developers and businesses alike. Whether
            you're building a simple website or a complex, scalable app, React
            provides the tools to do so efficiently and effectively.
          </p>

          <br />
          <br />

          <div className="text-sm">
            <p className="font-semibold">Naju.K</p>
            <p>September 10, 2024 ∙ 6 mins read</p>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </m.div>
  );
};

export default Blog2;
